import { render, staticRenderFns } from "./BibliotecaTonosTab.vue?vue&type=template&id=e7f0e0b4&scoped=true&"
import script from "./BibliotecaTonosTab.vue?vue&type=script&lang=js&"
export * from "./BibliotecaTonosTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f0e0b4",
  null
  
)

export default component.exports